module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/logo_visadebito.ed193bb5.png";